import React from 'react';

export default function TrustPill({ message }) {
  const { streaming, direct_answer, grounding_state, confidence, stopped_by_user, error } = message;

  if (stopped_by_user) {
    return <span className="glp1-trust-pill glp1-trust-pill--stopped">Stopped</span>;
  }

  if (error && error !== 'phi_not_allowed') {
    if (error === 'rate_limited') {
      return <span className="glp1-trust-pill glp1-trust-pill--rate-limit">Wait a moment</span>;
    }
    return <span className="glp1-trust-pill glp1-trust-pill--error">Couldn't answer</span>;
  }

  if (streaming && !direct_answer) {
    return <span className="glp1-trust-pill glp1-trust-pill--drafting">Drafting…</span>;
  }

  if (streaming && direct_answer) {
    return null;
  }

  if (grounding_state === 'pending') {
    return <span className="glp1-trust-pill glp1-trust-pill--checking">Checking CMS sources…</span>;
  }

  if (grounding_state === 'verified') {
    if (confidence === 'high') {
      return <span className="glp1-trust-pill glp1-trust-pill--grounded-high">CMS-grounded · High confidence</span>;
    }
    if (confidence === 'medium') {
      return <span className="glp1-trust-pill glp1-trust-pill--grounded-medium">CMS-grounded · Medium confidence</span>;
    }
    if (confidence === 'low') {
      return <span className="glp1-trust-pill glp1-trust-pill--grounded-low">CMS-grounded · Low confidence</span>;
    }
    return <span className="glp1-trust-pill glp1-trust-pill--grounded-high">CMS-grounded</span>;
  }

  if (grounding_state === 'review') {
    return <span className="glp1-trust-pill glp1-trust-pill--review">Review needed</span>;
  }

  return null;
}
